import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function SecurityPage() {
return (
  <>
    <Seo
      title="Σεμινάρια Security – ΚΔΒΜ2 ΘΗΣΕΑΣ"
      description="Προγράμματα κατάρτισης για προσωπικό ασφαλείας με ενημέρωση, υποστήριξη και πληροφορίες από το ΚΔΒΜ2 ΘΗΣΕΑΣ."
      keywords="security σεμινάρια, προσωπικό ασφαλείας, κατάρτιση security, ΘΗΣΕΑΣ"
      url="https://theseus.edu.gr/security"
      image="/security.jpg"
      structuredData={{
        "@context": "https://schema.org",
        "@type": "Course",
        name: "Σεμινάρια Security",
        description: "Προγράμματα κατάρτισης για προσωπικό ασφαλείας.",
        provider: {
          "@type": "EducationalOrganization",
          name: "ΚΔΒΜ2 ΘΗΣΕΑΣ",
          url: "https://theseus.edu.gr"
        }
      }}
    />
     <section className="min-h-screen bg-white">
      {/* HERO */}
      <div
        className="relative h-[320px] md:h-[420px] bg-cover bg-center"
        style={{ backgroundImage: "url(/security.jpg)" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 h-full flex flex-col justify-end pb-10">
          <nav className="text-sm text-white/80 mb-3">
            <Link to="/" className="hover:underline">
              Αρχική
            </Link>
            <span className="mx-2">→</span>
            <Link to="/#programs" className="hover:underline">
              Προγράμματα
            </Link>
            <span className="mx-2">→</span>
            <span className="text-white">Voucher Security</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-extrabold text-white">
            Voucher Security
          </h1>

          <p className="mt-3 max-w-3xl text-white/90">
            Πρόγραμμα κατάρτισης Προσωπικού Ιδιωτικής Ασφάλειας που οδηγεί σε
            πιστοποίηση και λήψη άδειας εργασίας προσωπικού ιδιωτικής ασφάλειας
            (security).
          </p>

          <div className="mt-4 flex flex-wrap gap-2">
            <span className="inline-flex rounded-full bg-white/90 px-3 py-1 text-xs font-semibold">
              105 ώρες
            </span>
            <span className="inline-flex rounded-full bg-white/90 px-3 py-1 text-xs font-semibold">
              Εξ αποστάσεως
            </span>
            <span className="inline-flex rounded-full bg-white/90 px-3 py-1 text-xs font-semibold">
              Πιστοποίηση / Άδεια
            </span>
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* LEFT */}
        <div className="lg:col-span-2 space-y-10">
          {/* Description */}
          <section className="space-y-4">
            <h2 className="text-xl font-extrabold">Περιγραφή</h2>
            <p className="text-gray-700 leading-relaxed">
              Πρόγραμμα κατάρτισης Προσωπικού Ιδιωτικής Ασφάλειας που οδηγεί σε
              πιστοποίηση και λήψη άδειας εργασίας προσωπικού ιδιωτικής ασφάλειας
              (security).
            </p>
            <p className="text-gray-700 leading-relaxed">
              Το σεμινάριο διαρκεί <span className="font-semibold">105 ώρες</span>, οι
              οποίες υλοποιούνται αποκλειστικά μέσω{" "}
              <span className="font-semibold">
                εξ αποστάσεως εκπαίδευσης (τηλεκατάρτισης)
              </span>
              .
            </p>
          </section>

          {/* Requirements */}
          <section className="space-y-4">
            <h2 className="text-xl font-extrabold">Προϋποθέσεις συμμετοχής</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
              <li>Ηλικία: τουλάχιστον 18 ετών</li>
              <li>Απολυτήριο υποχρεωτικής εκπαίδευσης</li>
            </ul>
          </section>

          {/* Certification / License */}
          <section className="space-y-4">
            <h2 className="text-xl font-extrabold">Βεβαίωση & Πιστοποίηση</h2>
            <p className="text-gray-700 leading-relaxed">
              Με την ολοκλήρωση της εκπαίδευσης χορηγείται βεβαίωση στον ωφελούμενο,
              η οποία είναι απαραίτητη για τη συμμετοχή στις εξετάσεις που διενεργούνται
              από τον Εθνικό Οργανισμό Πιστοποίησης Προσόντων και Επαγγελματικού
              Προσανατολισμού (Ε.Ο.Π.Π.Ε.Π.) και το Κέντρο Μελετών Ασφαλείας (ΚΕ.ΜΕ.Α.),
              ώστε να αποκτηθεί η άδεια εργασίας.
            </p>
          </section>

{/* CTA  */}
<section className="rounded-2xl bg-gray-900 text-white px-8 py-10 text-center">
  <h2 className="text-lg md:text-xl font-extrabold">
    ΕΚΔΗΛΩΣΗ ΕΝΔΙΑΦΕΡΟΝΤΟΣ / ΠΛΗΡΟΦΟΡΙΕΣ
  </h2>

  <p className="mt-4 max-w-2xl mx-auto text-white/90 text-base md:text-lg leading-relaxed">
    Για περισσότερες πληροφορίες μπορείτε να επικοινωνήσετε μαζί μας στο{" "}
    <span className="font-semibold whitespace-nowrap">2510 600205</span>.
  </p>

  <div className="mt-6 space-y-3">
    <a
      href="tel:2510600205"
      className="block w-full rounded-xl bg-white text-gray-900 px-5 py-4 font-bold text-center hover:bg-gray-100 transition"
    >
      Κλήση: 2510 600205
    </a>

    <Link
      to="/contact"
      className="block w-full rounded-xl bg-white/10 px-5 py-4 font-bold text-center hover:bg-white/15 transition"
    >
      Φόρμα Επικοινωνίας
    </Link>
  </div>
</section>

        </div>

        {/* RIGHT SIDEBAR */}
        <aside className="space-y-6">
          <div className="rounded-2xl border border-gray-200 p-5">
            <h3 className="font-extrabold mb-4">Γρήγορες Πληροφορίες</h3>

            <div className="space-y-3 text-sm">
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Διάρκεια</span>
                <span className="font-semibold text-right">105 ώρες</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Υλοποίηση</span>
                <span className="font-semibold text-right">Εξ αποστάσεως</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Ελάχιστη ηλικία</span>
                <span className="font-semibold text-right">18 ετών</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Τηλέφωνο</span>
                <span className="font-semibold text-right">2510 600205</span>
              </div>
            </div>

            <div className="mt-5 flex flex-col gap-2">
              <a
                href="tel:2510600205"
                className="block text-center rounded-xl bg-blue-600 px-4 py-3 font-bold text-white hover:bg-blue-700 transition"
              >
                Καλέστε τώρα
              </a>
              <Link
                to="/contact"
                className="block text-center rounded-xl bg-gray-900 px-4 py-3 font-bold text-white hover:bg-black transition"
              >
                Φόρμα Επικοινωνίας
              </Link>
            </div>
          </div>

          <div className="rounded-2xl border border-gray-200 p-5">
            <h3 className="font-extrabold mb-2">Σημείωση</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Η βεβαίωση ολοκλήρωσης είναι απαραίτητη για συμμετοχή στις εξετάσεις
              (Ε.Ο.Π.Π.Ε.Π. & ΚΕ.ΜΕ.Α.) για την απόκτηση άδειας εργασίας.
            </p>
          </div>
        </aside>
      </div>
    </section>
  </>
);
}